export type SortableUser = {
  f_name?: string | null;
  name?: string | null;
  m_name?: string | null;
  l_name?: string | null;
};

function getUserFullNameKey(user: SortableUser): string {
  if (user?.f_name) {
    return String(user.f_name).trim();
  }
  return [user?.name, user?.m_name, user?.l_name]
    .map((part) => (part ? String(part).trim() : ""))
    .filter(Boolean)
    .join(" ");
}

/** First name, then middle name, then last name (via derived f_name). */
export function sortUsersByFullName<T extends SortableUser>(
  users: T[] | null | undefined
): T[] {
  if (!Array.isArray(users)) {
    return [];
  }
  return [...users].sort((a, b) =>
    getUserFullNameKey(a).localeCompare(getUserFullNameKey(b), "en", {
      sensitivity: "base",
    })
  );
}
